define('views/modules/calendar/nutrition/food/list/food-list-item',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // service
    'services/user',
    'services/i18n',
    // models
    // 'models/calendar/nutrition/food-favorite',
    // views
    'views/modules/calendar/nutrition/food/list/base-food-item',
    'views/modules/calendar/nutrition/food/edit/food-edit-modal',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    User,
    i18n,
    // models
    // MFoodFavorite,
    // views
    VBaseFoodItem,
    VFoodEditModal
) {

    var VFoodItem = VBaseFoodItem.extend({
        events: {
            "click .food-name": "onClick",
            "click .food-add-basket": "onAddFavoriteClick",
            "touchstart .food-add-basket": "onAddFavoriteClick", //Mandatory for IPAD or click event isn't firing
            "click .food-edit": "onFoodEditClick",
            "item:move": "onMove",
            "item:clone": "onClone"
        },

        initialize: function(options) {
            options = options || {};
            this.favorite = options.favorite;
            this.listenTo(this.model, { 'change:name': this.render });
        },

        render: function() {
            VFoodItem.__super__.render.apply(this, arguments);
            this.updateFavoriteIcon();

            this.$('[data-toggle="tooltip"]').attr('title', i18n.t("calendar:Delete favorite"));
            this.$('[data-toggle="tooltip"]').tooltip();

            return this;
        },

        isFavorite: function() {
            return this.favorite.getFood(this.getFoodId()) || false;
        },

        updateFavoriteIcon: function(value) {
            if (_.isUndefined(value)) value = Boolean(this.isFavorite());
            this.$el.toggleClass('favorite', value);
        },

        getFoodId: function() {
            return this.model.id;
        },

        getFood: function() {
            return this.model;
        },

        showEditModal: function(attrs) {
            this.getFoodModal().resetModel(attrs).render();
        },

        getFoodModal: function() {
            var view = this.view,
                modal = view.create;
            if (!modal) {
                modal = view.create = new VFoodEditModal();
                this.listenTo(modal, { 'success': this.onEditSuccess });
            }
            return modal;
        },

        ////////////
        // events //
        ////////////
        onClick: function(e) {
            var isActive = !this.isActive();
            this.setActive(isActive);
            this.model.trigger('food:click', this.getFood(), isActive);
        },

        onAddFavoriteClick: function() {
            var favorite = this.isFavorite();
            this.updateFavoriteIcon(!favorite);
            if (favorite) {
                favorite.destroy();
            } else {
                this.favorite.create({
                    foodId: this.getFoodId(),
                    type: "food",
                    user: User.id
                });
            }
        },

        onFoodEditClick: function() {
            var model = this.getFood();
            model.fetch({
                context: this,
                success: function() {
                    this.showEditModal(model.toJSON());
                }
            });
        },

        onMove: function(e, context, callback, position) {
            // reset nutrient view
            var food = this.getFood(),
                view = this.view,
                nutrientView = view.nutrient;
            if (nutrientView) nutrientView.unfocus();

            if (food.toJSON) food = food.toJSON();

            this.setActive(false);
            callback.call(context, food, this, position);

            // use the duplicated element, as the original has left.
            this.setElement(this.cloneEl);
            this.$el.removeAttr('style');

            this.render();
        },

        onClone: function(e, cloneEl) {
            this.cloneEl = cloneEl;
        },
    });

    return VFoodItem;

});

